import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import './payment.css';
import qrCodeImage from './assets/images/payment_qr.jpg'; // Import the QR code image

const QRCodePage = () => {
    const navigate = useNavigate(); // Initialize the navigate function

    return (
        <div className="qr-code-page">
            <div className="qr-code-container">
                <h2 className="qr-code-title">Scan to Pay</h2>
                {/* Back Button */}
                <button
                    className="back-button"
                    onClick={() => navigate('/profile')} // Navigate to the profile page
                >
                    Back to Profile
                </button>
                {/* QR Code Image */}
                <img
                    className="qr-code-image"
                    src={qrCodeImage}
                    alt="QR Code"
                    style={{ width: '400px', height: 'auto' }} // Inline styles to increase size
                />
            </div>
        </div>
    );
};

export default QRCodePage;
